import { PagePlaceholder } from "../components/PagePlaceholder";

export function ConfigurationsPage() {
	return (
		<PagePlaceholder
			title="Configurations"
			subtitle="What configurations agents commit, abandon, and use post-placement."
			endpoint="/v1/insights/manufacturer/configurations"
			rails={[
				{ heading: "Configurator funnel", body: "Opened → Committed (committed / abandoned)." },
				{ heading: "Top configurations per product", body: "Stacked bar per configuration group." },
				{ heading: "Option preferences vs default", body: "'matte_black 52% (default: 24%)' style." },
				{ heading: "In use", body: "Brightness band, CCT band, on/off rate post-placement." },
			]}
		/>
	);
}
